<template>
	<div>
		<lazy-cdn-background-image v-if="$device.isDesktop" class="fixed w-full h-screen" :src="image ?? '/views/auth/spoferan-registration.jpg'" :ratio="1920/1080" :width="1920"
								   cover immediate/>

		<container xs-full>
			<div class="flex justify-center w-full sm:min-h-screen sm:items-center">
				<div class="w-screen sm:w-400 md:w-500 lg:w-600">
					<card class="min-h-screen sm:min-h-auto flex items-center justify-center" flat>
						<div class="pt-32 pb-32 px-28 sm:pt-36 sm:pb-28 sm:px-48 md:pt-48 md:px-64 w-full">
							<div class="flex" :class="{'justify-center items-center flex-column': icon || $slots.icon}">
								<slot name="icon"/>
								<lazy-icon v-if="icon" :icon="icon" x-large prominent :color="color" class="mb-20"/>
								<h1 v-if="title" class="text-black" :class="icon || $slots.icon ? 'text-center text-3xl md:text-4xl' : 'text-left text-5xl md:text-6xl'">{{ title }}</h1>
							</div>

							<slot/>

							<divider class="mt-8 mb-24"/>

							<nuxt-link :to="props.logo?.to ?? '/'" class="flex flex-column items-center justify-center">
								<cdn-image v-if="props.logo" :src="props.logo.path" :size="{ratio: props.logo.ratio, width: props.logo.width, height: props.logo.height}" alt="SPOFERAN"/>
								<cdn-image v-else :src="Images.favicon.path" :size="{ratio: Images.favicon.ratio, width: 32}" alt="SPOFERAN"/>

								<span class="mt-8 text-2xs">{{ props.logo?.to_text ?? $t('action.to_start_page') }}</span>
							</nuxt-link>
						</div>
					</card>
				</div>
			</div>
		</container>
	</div>
</template>

<script setup lang="ts">
import type {Image} from "@spoferan/spoferan-ts-core";
import {Images} from "@spoferan/spoferan-ts-core";

const props = withDefaults(defineProps<{
	title?: string,
	color?: string,
	icon?: string,
	image?: string | Image | null,
	logo?: {
		path: string,
		ratio: number,
		height?: number,
		width?: number,
	}
}>(), {});

</script>

